import React from 'react';
import style from './E2ES.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function EngineeringServices(props) {

  //check whether to render webp or png
  let imageType = "png"
  if (props.webp === "webp") {
    imageType = "webp"
  }

  let lifecycle = null
  if (props.windowSize !== "Mobile") {
    lifecycle = <div className={style.lifecycleGrid}>
      <h4 style={{msGridColumn: 1, msGridRow: 1}}>E&#178; Power Systems manages the complete project lifecycle</h4>
      <h6 style={{msGridColumn: 1, msGridRow: 2}}>Equipment<FontAwesomeIcon icon={['far', 'long-arrow-right']} /></h6>
      <h6 style={{msGridColumn: 2, msGridRow: 2}}>System Interface Design<FontAwesomeIcon icon={['far', 'long-arrow-right']} /></h6>
      <h6 style={{msGridColumn: 3, msGridRow: 2}}>Field Services</h6>
      <div style={{msGridColumn: 1, msGridRow: 3}}>E&#178; will conduct an initial feasibility study to determine necessary equipment. Whether you need complete system replacement or new equipment integrated into your existing system, we will help you determine the best solution for your project.</div>
      <div style={{msGridColumn: 2, msGridRow: 3}}>We know that the equipment you choose is only effective when the design is tailored for your application. Our extensive experience will ensure that the generation and electrical systems you use are custom made for you.</div>
      <div style={{msGridColumn: 3, msGridRow: 3}}>Once you have a system designed for your application, it&#39;s essential that your team has the support they need to manage the system effectively. We can supply this through a variety of services from compliance testing to technical training. Use us a little, use us a lot.</div>
    </div> 
  } else {
    lifecycle = <div className={style.lifecycleGrid}>
      <h4>E&#178; Power Systems manages the complete project lifecycle</h4>
      <div style={{msGridColumn: 1, msGridRow: 3}}>
        <h6>Equipment</h6>
        E&#178; will conduct an initial feasibility study to determine necessary equipment. Whether you need complete system replacement or new equipment integrated into your existing system, we will help you determine the best solution for your project.</div>
      <div className={style.arrowContainer} style={{msGridColumn: 1, msGridRow: 4}}><FontAwesomeIcon icon={['far', 'long-arrow-right']} transform={{ rotate: 60}} /></div>
      <div style={{msGridColumn: 1, msGridRow: 6, margin: "0px 0px 0px auto"}}>
        <h6>System Interface Design</h6>
        We know that the equipment you choose is only effective when the design is tailored for your application. Our extensive experience will ensure that the generation and electrical systems you use are custom made for you.</div>
      <div className={style.arrowContainer} style={{msGridColumn: 1, msGridRow: 7}}><FontAwesomeIcon icon={['far', 'long-arrow-right']} transform={{ rotate: 120}} /></div>
      <div style={{msGridColumn: 1, msGridRow: 9}}>
        <h6>Field Services</h6>
        Once you have a system designed for your application, it&#39;s essential that your team has the support they need to manage the system effectively. We can supply this through a variety of services from compliance testing to technical training. Use us a little, use us a lot.</div>
    </div>  
  }

  return (
    <div className={style.EngineeringServices}>
      <Head>  
        <title>E&#178; Engineering Services | Basler Services</title>
			</Head>
      <h1>Services We Offer</h1>
      <h2>E&#178; Engineering Services</h2>
      <div className={style.sectionGrid}>
        <div className={style.section} style={{msGridColumn: 1, msGridRow: 1}}>
          {lifecycle}
          <div className={style.lifecycleStyleBoxOne}></div>
          <div className={style.lifecycleStyleBoxTwo}></div>  
        </div> 
        <div className={`${style.section} ${style.tiu}`} style={{msGridColumn: 1, msGridRow: 2}}>
          <div className={`${style.styleImg} ${style.tiuStyleOne}`}></div>
          <div className={style.mainImage}>
            <Image 
              src={"/Assets/Images/inside_of_cabinet." + imageType}
              alt="Inside of excitation cabinet"
              layout="fill"
              objectFit="cover"
              priority
            />
          </div>
          <div className={style.info}>
            <h4>Turnkey Installation Upgrades</h4>
            <p>With our extensive experience in developing and delivering turnkey projects, we have learned that sometimes the best solutions result from the combining of resources. Specific Installation Support Services Packages are quoted depending on the specific tasks with which our clients choose to be directly involved. Use us a little, use us a lot.</p>
            <Link href={'/e2-engineering-services/turnkey-installation-upgrades'}><a className={`${style.cta} ${style.primaryCta}`}>View Turnkey Services <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
          </div>
        </div>
        <div className={`${style.section} ${style.esd}`} style={{msGridColumn: 1, msGridRow: 3}}>
          <div className={style.mainImage}>
            <Image 
              src={"/Assets/Images/system_design." + imageType}
              alt="System design"
              layout="fill"
              objectFit="cover"
              priority
            />
          </div>
          {props.windowSize !== "Mobile" ? <img className={`${style.styleImg} ${style.esdStyleOne}`} alt="s3 style grid" src={'/Assets/Images/s1_style_grid.' + imageType}/> : null}
          <div className={`${style.styleImg} ${style.esdStyleTwo}`}></div>
          <div className={style.info}>
            <h4>Electrical System Design</h4>
            <p>Proper system operation and reliability begins with the design process. It is critical that system designs are based on the needs of the user and the proper application of equipment and systems. Our extensive experience provides us with the skills to provide solutions tailored to customer needs on all types of generating and electrical systems.</p>
            <Link href={'/e2-engineering-services/electrical-system-design'}><a className={`${style.cta} ${style.primaryCta}`}>View System Design Services <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
          </div>
        </div>
        <div className={`${style.section} ${style.os}`} style={{msGridColumn: 1, msGridRow: 4}}>
          <div className={style.mainImage}>
            <Image 
              src={"/Assets/Images/Engineer_conducting_test." + imageType}
              alt="Engineer conducting test"
              layout="fill"
              objectFit="cover"
              priority
            />
          </div>
          {props.windowSize !== "Mobile" ? <img className={`${style.styleImg} ${style.osStyleOne}`} alt="s2 style grid" src={'/Assets/Images/s2_style_grid.' + imageType}/> : null}
          {props.windowSize !== "Mobile" ? <img className={`${style.styleImg} ${style.osStyleTwo}`} alt="s2 style grid" src={'/Assets/Images/s2_style_grid.' + imageType}/> : null}
          <div className={style.info}>
            <h4>Onsite Services</h4>
            <p>We know that projects aren&#39;t finished when the installation is complete. Maintaining compliance regulations, ensuring your systems are running effectively, and ensuring staff are supported are ongoing concerns. Our clients can feel at ease during this phase of the project by using some or all of the various onsite services we offer, such as NERC compliance testing, technical training, and system maintenance.</p>
            <Link href={'/e2-engineering-services/onsite-services'}><a className={`${style.cta} ${style.primaryCta}`}>View Onsite Services <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
          </div>
        </div>
        <div className={`${style.section} ${style.cs}`} style={{msGridColumn: 1, msGridRow: 5}}>
          <div className={style.mainImage}>
            <Image 
              src={"/Assets/Images/Two_senior_engineers." + imageType}
              alt="Two senior engineers at desk"
              layout="fill"
              objectFit="cover"
              priority
            /></div>
          {props.windowSize !== "Mobile" ? <img className={`${style.styleImg} ${style.csStyleOne}`} alt="s3 style grid" src={'/Assets/Images/s3_style_grid.' + imageType}/> : null}
          <div className={`${style.styleImg} ${style.csStyleTwo}`}></div>
          <div className={style.info}>
            <h4>Consulting Services</h4>
            <p>In addition to on-site support, we offer advanced consulting services to ensure your project gets up and running smoothly. Whether you are evaluating equipment needs or performing detailed system studies, our experienced engineers will provide the direction you need to ensure your operations are safe and efficient.</p>
            <Link href={'/e2-engineering-services/consulting-services'}><a className={`${style.cta} ${style.primaryCta}`}>View Consulting Services <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EngineeringServices;